export default __webpack_public_path__ + "static/media/Chantix 3.99153207.png";